import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static targets = ["chart"]
  static values = {
    attendanceId: Number
  }

  connect() {
    this.loadTrackingData()
  }

  async loadTrackingData() {
    try {
      const response = await fetch(`/staff_trackings/sparkline_data?attendance_id=${this.attendanceIdValue}`)
      const data = await response.json()
      this.renderChart(data)
    } catch (error) {
      console.error('Error loading tracking data:', error)
    }
  }

  renderChart(data) {
    const options = {
      series: [{
        name: 'Trackings',
        data: data.trackingData
      }],
      chart: {
        type: 'bar',
        width: 100,
        height: 30,
        stacked: true,
        sparkline: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '5',
          colors: {
            ranges: [{
              from: 0,
              to: 0.5,
              color: '#e5e7eb' // gray for incomplete
            }, {
              from: 1,
              to: 1,
              color: '#3b82f6' // blue for completed
            }]
          }
        }
      },
      xaxis: {
        type: 'category',
        categories: data.trackingTimes,
        labels: {
          show: false
        },
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 1
      },
      grid: {
        show: false
      },
      tooltip: {
        fixed: {
          enabled: true,
          position: 'bottomLeft',
          offsetX: 10,
          offsetY: -15,
        },
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          const time = w.config.xaxis.categories[dataPointIndex];
          const status = series[seriesIndex][dataPointIndex] === 1 ? 'Completed' : 'Incomplete';
          return `<div class="p-2 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
            <div class="text-sm font-medium text-gray-900 dark:text-white">${time}</div>
            <div class="text-sm text-gray-500 dark:text-gray-400">${status}</div>
          </div>`;
        }
      }
    }

    const chart = new ApexCharts(this.element, options);
    chart.render();
  }
}
